import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../components/core/basic/Button";
import { Accordion } from "../../../../components/core/basic/Accordion";
import { Flex } from "../../../../../styled-system/jsx";
import { css } from "../../../../../styled-system/css";
import { AdvertisingAccountsTable } from "../../../onboarding/amazon/AdvertisingAccountsTable";
import { ManageAMCInstancesModal } from "./ManageAMCInstancesModal";

export function AMCInstanceSection() {
  const { t } = useTranslation(["amc"]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={css({ width: "100%", paddingTop: "3.5rem" })}>
      <Accordion title={t(($) => $.amc["Amazon Account IDs"])} marginTop="0">
        <div className={css({ width: "100%", textAlign: "start", color: "#393939" })}>
          <Flex justifyContent={"space-between"} alignItems="center">
            <h2 className={css({ fontSize: "28px", fontWeight: 600 })}>{t(($) => $.amc["Amazon Account IDs"])}</h2>
            <Button onPress={() => setIsModalOpen(true)}>{t(($) => $.amc["Manage AMC Instances"])}</Button>
          </Flex>
          <AdvertisingAccountsTable />
        </div>
      </Accordion>
      <ManageAMCInstancesModal isOpen={isModalOpen} onOpenChange={setIsModalOpen} />
    </div>
  );
}
